const languages = {
  eng: 'English',
  arabic: 'Arabic',
  rus: 'Russian',
  spanish: 'Spanish',
  french: 'French',
};

export default languages;
